import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { usePrincipal } from "../../auth/AuthContext";
import { ownerOf } from "../hub/hubs";

// The branded print header and footer, mounted once in the shell and visible only when printing (index.css
// "@media print"). Navy band with the emblem, the product, the page title, who printed it, and the closing
// "uncontrolled copy" line — so a sheet taken to the floor says where it came from and when.

export function PrintBrand() {
  const { pathname } = useLocation();
  const principal = usePrincipal();
  const [title, setTitle] = useState(ownerOf(pathname)?.item.label ?? "Summit Operations");
  useEffect(() => {
    const updateTitle = (event?: Event) => {
      const detail = event instanceof CustomEvent ? event.detail : null;
      const documentTitle = document.title.replace(/\s+\|\s+Summit Operations$/, "").trim();
      const next = typeof detail === "string" && detail ? detail : documentTitle;
      if (next && next !== "Summit Operations") setTitle(next);
    };
    window.addEventListener("summitops:print-title", updateTitle);
    updateTitle();
    return () => window.removeEventListener("summitops:print-title", updateTitle);
  }, [pathname]);
  const printedBy = principal?.displayName ?? "Not signed in";
  const plantDate = principal?.plantDate;

  return (
    <>
      <div className="print-brand hidden print:flex" aria-hidden="true">
        <img src="/favicon/apple-touch-icon.png" alt="" className="print-brand-emblem" />
        <span className="print-brand-name">
          <span className="print-brand-product">Summit Operations</span>
          <span className="print-brand-company">Summit Aviation, Inc.</span>
        </span>
        <span className="print-brand-page">
          <span className="print-brand-title">{title}</span>
          <span className="print-brand-meta">
            Printed by {printedBy}
            {plantDate ? ` · plant date ${plantDate}` : ""}
          </span>
        </span>
      </div>
      <div className="print-brand-footer hidden print:flex" aria-hidden="true">
        <span>Summit Operations · Summit Aviation, Inc.</span>
        <span>Uncontrolled copy when printed. Check Summit Operations for the current figures.</span>
      </div>
    </>
  );
}
